import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";

export interface StorefrontTrackingConfig {
  redoBaseRequestUrl: string;
  merchantWidgetId: string;
  splitEnabled?: boolean;
  customerAccountsEnabled?: boolean;
  marketingEnabled?: boolean;
  expandedWarrantyEnabled?: boolean;
  storefrontSalesAIEnabled?: boolean;
  conversionEnabled?: boolean;
  conciergeSplitEnabled?: boolean;
  coverageProductIds?: string[];
}

export const getStorefrontTrackingConfigFromShopifyWebPixelSettings = ({
  shopifyWebPixelSettings,
}: {
  shopifyWebPixelSettings: Record<any, any>;
}): StorefrontTrackingConfig => {
  return {
    redoBaseRequestUrl:
      shopifyWebPixelSettings.baseRequestUrl ||
      shopifyWebPixelSettings.base_request_url, // If this is present, it's an old version of the extension
    merchantWidgetId:
      shopifyWebPixelSettings.widgetId || shopifyWebPixelSettings.widget_id, // If widget_id is present, it's an old version of the extension
    splitEnabled: shopifyWebPixelSettings.splitEnabled === "true",
    customerAccountsEnabled:
      shopifyWebPixelSettings.customerAccountsEnabled === "true",
    marketingEnabled: shopifyWebPixelSettings.marketingEnabled === "true",
    expandedWarrantyEnabled:
      shopifyWebPixelSettings.expandedWarrantyEnabled === "true",
    storefrontSalesAIEnabled:
      shopifyWebPixelSettings.storefrontSalesAIEnabled === "true",
    conversionEnabled: shopifyWebPixelSettings.conversionEnabled === "true",
    coverageProductIds: (() => {
      try {
        const parsed = JSON.parse(
          shopifyWebPixelSettings.coverageProductIds ?? "",
        );
        return Array.isArray(parsed) ? parsed.map(String) : undefined;
      } catch {
        return undefined;
      }
    })(),
  };
};

export const getStorefrontTrackingConfigFromAutocheck = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}): StorefrontTrackingConfig => {
  if (!autocheck.widgetSlug) {
    throw new Error("Widget slug is required");
  }
  return {
    redoBaseRequestUrl: "https://shopify-server.getredo.com/widgets",
    merchantWidgetId: autocheck.widgetSlug,
    splitEnabled: !!autocheck.treatments?.length,
    coverageProductIds: autocheck.coverageProductIds,
  };
};
